"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formatAbstractDate = _interopRequireDefault(require("../internal/utils/formatAbstractDate"));

var _default = function _default(value, type) {
  return (0, _formatAbstractDate.default)({
    value: value,
    type: type,
    format: 'MD',
    length: 's'
  });
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/utils/formatShortDate.js
// module id = 776
// module chunks = 209 210 211 212